<template>
    <div class="background">
        <HeaderHome :user="this.$store.state.user.prenom"/>
        <div class="greeting">
          <h1>Récap de vos heures</h1>
          <p>Vous retrouverez ici le récap de vos heures</p>
        </div>
        <div class="table">
            <DataTable :value="apointments" tableStyle="width: 100%">
                <Column field="ladate" header="date"></Column>
                <Column field="heure" header="heure"></Column>
                <Column field="eleve.fullname" header="Elève"></Column>
                <Column field="lieuDeb.nom" header="Début"></Column>
                <Column field="lieuFin.nom" header="Fin"></Column>
            </DataTable>
        </div>
    </div>
  </template>
  
  <script>
import HeaderHome from "@/components/home/HeaderHome.vue";
  export default {
  
      props: [

      ],
  
    components: {
        HeaderHome
    },
  
    watch: {},
  
    data() {
      return {
        apointments: [],
      };
    },
  
    mounted() {
        this.getHeures();
    },
  
    methods: {

        getHeures(){
            window.api
            .get("/moniteur/heures/" + this.$store.state.user.id, {
            headers: {
                Authorization: "Bearer " + this.$store.state.token,
            },
            })
            .then((response) => {
                this.apointments = response.data.apointments;
            })
            .catch((error) => {
            console.log(error);
            });
        },

    }
  };
  </script>
  
  <style scoped>
  
  div.background {
        background-color: #F4F6F9;
        min-height: 100vh;
        padding-bottom: 1rem;
  }

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}


/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

div.greeting{
  width: 90%;
  margin: auto;
  text-align: left;
  margin-top: 1rem;
}

div.greeting h1{
  margin: 0;
  font-weight: bold;
}

div.greeting p{
  color: #666666;
}

div.table{
    width: 90%;
    margin: auto;
}
  
  </style>
  